<template>

    <b-modal v-if="entity"
             v-model="modalTransactionUser"
             size="md"
             no-close-on-backdrop
             hide-footer
             :title="`${$t('labels.showOperations')}
             ${entityType == 'CLIENT' ? $t('labels.client').toLowerCase() + ' ' + entity.name :
             $t('labels.user').toLowerCase() + ' ' + '@'+entity.userName}`">

          <b-row>
              <b-col cols="6">
                  <b-form-group :label="$t('labels.currency')">
                      <validation-provider
                              #default="{ errors }"
                              name="currency"
                      >
                          <v-select
                                  v-model="currency"
                                  :placeholder="$t('labels.currency')"
                                  :clearable="false"
                                  label="name"
                                  @input="[
                                    currency ? getTransactions(entity._id, entityType, currency._id) : transaction = [],
                                    getBalance(currency._id)
                                    ]"
                                  :options="currencies"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                  </b-form-group>
              </b-col>

              <b-col cols="6" v-if="entity.wallet">
                  <div class="d-flex align-items-center justify-content-center mr-3">

                      <b-avatar variant="light-primary"
                                rounded
                                size="65px">
                          <coin-avatar :abv="currency.abv"></coin-avatar>
                      </b-avatar>

                      <div class="ml-1">
                          <h5 class="mb-0">
                              {{entityBalance}}
                          </h5>
                          <small>{{$t('labels.balance')}}</small>
                      </div>
                  </div>
              </b-col>

          </b-row>

        <div v-if="fetchingTransactions" class="d-flex justify-content-center align-items-center p-1">
            <b-spinner type="grow"></b-spinner>
        </div>

        <div v-else-if="transaction.length > 0" class="mb-2" >

            <b-list-group
                    v-for="(item,index) in transaction" :key="index">

                <b-list-group-item class="d-flex justify-content-between align-items-center"
                                   style="margin-bottom: 5px"
                                   @click="showTransactionCollapse(index)">

                    <div class="d-flex flex-row align-items-center">
                        <b-avatar :variant="isDebit(item.typeTransaction) ? 'light-danger' : 'light-success'"
                                  rounded class="mr-1"
                                  size="25px">
                            <feather-icon
                                    :icon="isDebit(item.typeTransaction) ? 'ArrowUpRightIcon' : 'ArrowDownRightIcon'"
                                    size="15"/>
                        </b-avatar>

                        <div class="d-flex flex-column justify-content-start">
                            <div v-if="item.detail">{{item.detail}}</div>
                            <div v-else>{{isDebit(item.typeTransaction) ? 'Debit' : 'Credit'}}</div>
                            <div class="font-small-2">{{formatCreatedAt(item.createdAt)}}</div>
                            <div class="font-small-1 text-danger">
                              {{checkTransaction(index,item._id) == true ? $t('labels.corruptTransaction') : ''}}
                            </div>
                        </div>

                    </div>

                    <div :class="isDebit(item.typeTransaction) ? 'text-danger' : 'text-success'">
                      {{ $n(formatTransactionTypeAmount(item.typeTransaction,item.amount), 'currency') }}
                      <!--{{formatTransactionTypeAmount(item.typeTransaction,item.amount)}}-->
                    </div>

                </b-list-group-item>

                <b-collapse v-model="collapseTransactionDetail[index]" :refs="updateTest"  class="mt-2">
                    <b-card>
                        <b-row style="margin-bottom: 10px">

                            <b-col cols="6">
                              {{ $t('labels.type') }}:
                            </b-col>

                            <b-col cols="6" class="d-flex justify-content-end"
                                   :class="item.typeTransaction == 'CREDIT' ? 'text-success' : 'text-danger'">
                                {{item.typeTransaction == 'CREDIT' ? $t('labels.credit') : $t('labels.debit') }}
                            </b-col>

                        </b-row>

                        <b-row v-if="item.entityFrom && item.entityTo">

                        <b-col cols="6">
                          {{ item.typeTransaction == 'CREDIT' ? $t('labels.from') : $t('labels.to') }}:
                        </b-col>

                        <b-col cols="6" class="d-flex justify-content-end"
                               v-if="item.typeTransaction == 'CREDIT' && item.entityFrom.type == 'CLIENT'">
                          {{ item.entityFrom.entity.name  }}
                        </b-col>

                          <b-col cols="6" class="d-flex justify-content-end"
                                 v-if="item.typeTransaction == 'CREDIT' && item.entityFrom.type == 'USER'">
                            {{ item.entityFrom.entity.email  }}
                          </b-col>

                          <b-col cols="6" class="d-flex justify-content-end"
                                 v-if="item.typeTransaction == 'DEBIT' && item.entityTo.type == 'CLIENT'">
                            {{ item.entityTo.entity.name  }}
                          </b-col>

                          <b-col cols="6" class="d-flex justify-content-end"
                                 v-if="item.typeTransaction == 'DEBIT' && item.entityTo.type == 'USER'">
                            {{ item.entityTo.entity.email  }}
                          </b-col>

                      </b-row>

                        <b-row v-if="item.entityFrom && item.entityTo">

                        <b-col cols="6">
                          {{ item.typeTransaction == 'CREDIT' ? $t('labels.fromType') : $t('labels.toType') }}:
                        </b-col>

                        <b-col cols="6" class="d-flex justify-content-end">
                          {{item.typeTransaction == 'CREDIT' ? item.entityFrom.type  : item.entityTo.type}}
                        </b-col>

                      </b-row>

                    </b-card>
                </b-collapse>

            </b-list-group>

        </div>

        <div v-else class="p-1 d-flex justify-content-center">{{$t('labels.noOperations')}}</div>

    </b-modal>
</template>

<script>
  import { VueGoodTable } from 'vue-good-table'
  import {
    BCollapse,
    BCard,
    BAvatar,
    BBadge,
    BButton,
    BCol,
    BListGroup,
    BListGroupItem,
    BOverlay,
    BRow,
    BSpinner,
    VBModal,
    BFormGroup,
  } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import Ripple from 'vue-ripple-directive'
  import { mapActions } from 'vuex'
  import moment from 'moment'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import CoinAvatar from '../currencies/CoinAvatar'

  export default {
    name: 'TransactionModal',
    components: {
      BCollapse,
      CoinAvatar,
      BFormGroup,
      ValidationProvider,
      ValidationObserver,
      VueGoodTable,
      BAvatar,
      BBadge,
      BListGroupItem,
      BListGroup,
      VBModal,
      BButton,
      vSelect,
      BOverlay,
      BSpinner,
      BRow,
      BCol,
      BCard
    },

    directives: {
      'b-modal': VBModal,
      Ripple,
    },

    data() {
      return {
        entity: '',
        transaction: [],
        modalTransactionUser: false,
        fetchingTransactions : false,
        currency : '',
        currencies : [],
        entityType : '',
        entityBalance : '',
        collapseTransactionDetail : [],
        updateTest : 0,
        invalidRowIds : []
      }
    },

    methods: {
      ...mapActions('transaction', ['showTransactionsByUserClientId','validationRow']),
      ...mapActions('user', ['showUserBalance']),
      ...mapActions('client', ['showClientBalance']),

      isDebit(transactionType) {
        let isDebitFlag = false
        if (transactionType.toLowerCase() === 'debit') {
          isDebitFlag = true
        }
        return isDebitFlag
      },

      checkTransaction(index,id){
        if (Array.isArray(this.invalidTransactionsIds) && this.invalidTransactionsIds.length > 0){
          if (this.invalidTransactionsIds.includes(this.transaction[index]._id))
            return true
        }
      },

      showModal(entity,defaultCurrency, currencyList,type) {
        this.entityType = type
        this.entity = entity
        this.currency = defaultCurrency
        this.currencies = currencyList
        this.getTransactions(entity._id, this.entityType, this.currency._id)
        this.getBalance(this.currency._id)
        this.validationRow()
            .then(response =>{
              this.invalidTransactionsIds = response
              if (Array.isArray(this.transaction.length) && this.transaction.length > 0){
               // for (let i = 0; i < this.transaction.length; i++){
               //   alert(this.transaction[i]._id)
               //   if (invalidTransactionsIds.includes(this.transaction[i]._id))
               //     this.transaction[i].invalid = true
               // }
              }
            })
        this.modalTransactionUser = true
      },

      async getTransactions(entityId, entityType, currencyId) {
        this.fetchingTransactions = true
        this.showTransactionsByUserClientId({ entityId, entityType, currencyId })
          .then((response) => {
            this.transaction = response
          })
          .finally(()=>{
            this.fetchingTransactions = false
          })
      },

      formatTransactionTypeAmount(transactionType, amount) {
        if (transactionType.toLowerCase() === 'debit') {
          return amount * -1
        } else {
          return amount
        }
      },

      formatCreatedAt: function(value) {
        return moment(String(value)).format('DD-MM-YYYY HH:MM')
      },

      async getBalance(currencyId){
        if (currencyId){
          let showBalance = ''
          if (this.entityType === 'USER' && this.entity.wallet){
            showBalance = await this.showUserBalance({userId: this.entity._id , currencyId : currencyId})
          } else if (this.entityType === 'CLIENT'){
            showBalance = await this.showClientBalance({clientId: this.entity._id , currencyId : currencyId})
          }

          if (showBalance){
            this.entityBalance = showBalance[0].balance.toFixed(2)
          }

        }

      },

      showTransactionCollapse(index){
        if (this.collapseTransactionDetail[index] === undefined || this.collapseTransactionDetail[index] === false )
          this.collapseTransactionDetail[index] = true
        else if (this.collapseTransactionDetail[index] === true)
          this.collapseTransactionDetail[index] = false
        this.updateTest +=1

      }

    },

  }
</script>

<style scoped>

</style>